export type UploadEvent = {
  progress: number;
  done: boolean;
  error?: string;
};

export default function uploadFile(file: File, uploadUrl: string, callback: (event: UploadEvent) => void): () => void {
  const xhr = new XMLHttpRequest();
  let done = false;
  let progress = 0;

  xhr.upload.onprogress = (evt: ProgressEvent): void => {
    if (evt.lengthComputable) {
      progress = (evt.loaded / evt.total) * 100;
      callback({ progress, done });
    }
  };

  xhr.onreadystatechange = (): void => {
    if (xhr.readyState === 4) {
      done = true;
      if (xhr.status === 200) {
        callback({ progress, done });
      } else {
        callback({ progress, done, error: xhr.statusText });
      }
    }
  };

  xhr.open('PUT', uploadUrl);
  xhr.send(file);

  // Return cancel function
  return (): void => {
    if (!done) {
      xhr.abort();
    }
  };
}
